import React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { ReactComponent as Logo } from "../../images/valoo-logo.svg";
import { FormControlLabel, Checkbox } from "@mui/material";
import UsersTypeEnum from "constants/UsersTypeEnum";

const headings = {
  [UsersTypeEnum.Seller]: {
    title: "Let’s Get Started",
    subtitle: "Submit Your Seller Offering",
    newsletterLabel: "I would like to receive updates from Valoo",
  },
};

const RegisterGuestUser = ({ userType, handleSubmitForm, loading }) => {
  const [errorMessage, setErrorMessage] = React.useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    setErrorMessage("");
    const data = new FormData(event.currentTarget);

    const form = event.currentTarget;
    if (!form.checkValidity()) {
      // Mark the invalid fields with the "invalidInput" class
      const invalidElements = form.querySelectorAll(":invalid");
      invalidElements.forEach((element) => {
        element.classList.add("invalidInput");
      });

      setErrorMessage("Please fill in all required fields.");
      return; // Prevent form submission
    } else {
      // Remove the "invalidInput" class from all elements
      const allElements = form.elements;
      for (let i = 0; i < allElements.length; i++) {
        allElements[i].classList.remove("invalidInput");
      }
    }

    // Validate the form fields
    const fullName = data.get("fullName");
    const phone = data.get("phone");
    const email = data.get("email");

    if (!fullName || !phone || !email) {
      setErrorMessage("Please fill in all required fields.");
      return; // Prevent form submission
    }

    const isPhoneValid = /^[+\d\s()-]+$/g.test(phone);

    if (!isPhoneValid) {
      setErrorMessage("Please enter a valid phone number.");
      return;
    }

    try {
      const newsletter = data.get("newsletter") === "on";

      const payload = {
        email: email,
        fullname: fullName,
        phone: phone,
        newsletter: Boolean(newsletter),
      };
      handleSubmitForm(payload);
    } catch (error) {
      console.error("Error during registration:", error);
      setErrorMessage("An error occurred during registration");
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Logo alt="Valoo Logo" />
        <div className="separatorEmptyLarge"></div>
        <div className="separatorEmptyLarge"></div>
        <Typography component="h1" variant="h5">
          {headings[userType]?.title || "Join Valoo Community!"}
        </Typography>
        <div className="separatorEmptyMedium"></div>
        <div>
          {headings[userType]?.subtitle || "Let's Personalize Your Experience"}
        </div>
        <div className="separatorEmptyLarge"></div>
        {errorMessage && (
          <Typography variant="body2" color="error">
            {errorMessage}
          </Typography>
        )}
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            name="fullName"
            label="Full Name"
            id="fullName"
            autoComplete="name"
            onBlur={(e) => e.target.classList.remove("invalidInput")}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="email"
            label="Email"
            id="email"
            autoComplete="email"
            onBlur={(e) => e.target.classList.remove("invalidInput")}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="phone"
            label="Phone"
            id="phone"
            autoComplete="tel"
            onBlur={(e) => e.target.classList.remove("invalidInput")}
          />
          <FormControlLabel
            control={<Checkbox size="small" name="newsletter" defaultChecked />}
            label={
              <Typography variant="body2">
                {headings[userType]?.newsletterLabel ||
                  "I want to know about the latest news"}
              </Typography>
            }
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2, textTransform: "none" }}
            style={{ borderRadius: 20 }}
            color="orange"
            disabled={loading}
          >
            {loading ? "Saving..." : "Next"}
          </Button>

          <div className="separatorEmptyLarge"></div>
        </Box>
      </Box>
    </Container>
  );
};

export default RegisterGuestUser;
